import { render, staticRenderFns } from "./DerSignUpModule.vue?vue&type=template&id=14ab648c&"
import script from "./DerSignUpModule.ts?vue&type=script&lang=ts&"
export * from "./DerSignUpModule.ts?vue&type=script&lang=ts&"
import style0 from "./DerSignUpModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports